import Client from "../client";
import ProjectWorker from "@/entities/project-worker";
import ProjectWorkerGateway from "@/gateways/project-worker-gateway";
import { StaffId, ProjectId } from "@/entities/ids";

export default class ProjectWorkerApi implements ProjectWorkerGateway {
  public constructor(private client: Client, private projectId: ProjectId) {}

  public async all() {
    const workers: ProjectWorker[] = await this.client.get("get_workers.php", {
      projectId: this.projectId
    });
    return workers.map(toWorker);
  }

  public async favorites() {
    const workers: ProjectWorker[] = await this.client.get("get_workers.php", {
      projectId: this.projectId,
      favorite: 1
    });
    return workers.map(toWorker);
  }

  public async assigned() {
    return (await this.all()).filter(m => m.assigned);
  }

  public async unassigned() {
    return (await this.all()).filter(m => !m.assigned);
  }

  public async unassignedAndFavorite() {
    return (await this.favorites()).filter(m => !m.assigned);
  }

  /**
   * 現場に作業者を追加する
   */
  public async assign(id: StaffId) {
    const d = new FormData();
    d.append("staffId", String(id));
    d.append("projectId", String(this.projectId));

    await this.client.post("save_project_worker.php", d);
  }

  public async unassign(id: StaffId) {
    const d = new FormData();
    d.append("staffId", String(id));
    d.append("projectId", String(this.projectId));
    await this.client.post("remove_project_member.php", d);
  }
}

function toWorker(data: any): ProjectWorker {
  return {
    ...data,
    inviteStatus: toInviteStatus(data.inviteStatus)
  };
}

function toInviteStatus(id: number) {
  if (id === 1) {
    return "登録済";
  }
  if (id === 2) {
    return "招待済";
  }
  return "未招待";
}
